import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getInterviews = async () => {
  const response = await axios.get(`${base_url}interview/getInterview`);
 
  return response.data;
  
};
const createInterviews = async (formData) => {
  const response = await axios.post(`${base_url}interview/addInterview`, formData);
 
  return response.data;
};
const updateInterview = async (News) => {
  const response = await axios.put(
    `${base_url}interview/editInterview/${News.id}`,
    { title: News.NewsData.title , videos: News.NewsData.videos , category:News.NewsData.category},
    config
  );

  return response.data;
};

const getInterview = async (id) => {
  const response = await axios.get(`${base_url}interview/getById/${id}`, config);

  return response.data;
};

const deleteInterview = async (id) => {
  const response = await axios.delete(`${base_url}interview/deleteInterview/${id}`, config);

  return response.data;
};
const InterviewService = {
  getInterviews,
  createInterviews,
  getInterview,
  updateInterview,
  deleteInterview,
};

export default InterviewService;
